module.exports = __webpack_public_path__ + "img/home-title-tw.6d3c683f.svg";